export default "__VITE_ASSET__DJipGewW__"